module.exports = __webpack_public_path__ + "static/media/donate.1df0c54c.jpg";